import styled from 'styled-components/macro';
import AriaButton from './AriaButton';

const IconButton = styled(AriaButton)`
  margin: 0;
  padding: 0;
  border: 0;

  background: transparent;
  font-size: inherit;
  color: inherit;
  cursor: pointer;

  &[aria-disabled='true'] {
    cursor: not-allowed;
  }
`;

export default IconButton;
